import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { RdsBadgeComponent } from '@rds/angular-components';

import { EventDateTimePipe, RoomBookingModel } from '@bookly/shared';

/**
 * A single booking rendered as a card, for viewports too narrow for the
 * six-column table. Presentational only — it takes the booking through an
 * input and leaves click handling to whoever places it.
 */
@Component({
  selector: 'bad-booking-card',
  templateUrl: './booking-card.component.html',
  styleUrl: './booking-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'button',
    tabindex: '0',
  },
  imports: [RdsBadgeComponent, EventDateTimePipe],
})
export class BookingCardComponent {
  public readonly booking = input.required<RoomBookingModel>();

  /** Requester plus any on-behalf participants, as one comma-separated line. */
  protected readonly requesterNames = computed(() => {
    const booking = this.booking();
    return [
      booking.requester.fullName,
      ...(booking.onBehalfParticipants ?? []).map(
        participant => participant.fullName
      ),
    ].join(', ');
  });

  protected readonly serviceBadges = computed(
    () => this.booking().servicesBadge ?? []
  );
}
